export const sharedPrinterNotfoundDescription =
  'Sorry, the shared printer you requested could not be found. Please make sure that the printer owner has not turned off sharing and that you have the correct share link URL.';
